import type { ReactNode } from 'react';

export type PaymentOptionProps = {
  /** Identificador (`data-opt`), ex.: `card`, `pix`. */
  value: string;
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  selected?: boolean;
  onSelect?: () => void;
  /** Método desligado nas configurações: some do preview. */
  hidden?: boolean;
};

/** Forma de pagamento do checkout (`.opt` + `.radio`); a cor do selecionado vem de `--ck`. */
export function PaymentOption({ value, icon, title, description, selected = false, onSelect, hidden = false }: PaymentOptionProps) {
  return (
    <button type="button" className={`opt${selected ? ' sel' : ''}`} data-opt={value} aria-pressed={selected} style={{ display: hidden ? 'none' : undefined }} onClick={onSelect}>
      <span className="ic">{icon}</span><span><b>{title}</b><small>{description}</small></span><span className="radio"></span>
    </button>
  );
}
